export const GET_JOB_POST_DATA_LOADING = "GET_JOB_POST_DATA_LOADING";
export const GET_JOB_POST_DATA_SUCCESS = "GET_JOB_POST_DATA_SUCCESS";
export const GET_JOB_POST_DATA_FAILURE = "GET_JOB_POST_DATA_FAILURE";

export const GET_CITY_LOADING = "GET_CITY_LOADING";
export const GET_CITY_SUCCESS = "GET_CITY_SUCCESS";
export const GET_CITY_FAILURE = "GET_CITY_FAILURE";

export const GET_LOCALITY_LOADING = "GET_LOCALITY_LOADING";
export const GET_LOCALITY_SUCCESS = "GET_LOCALITY_SUCCESS";
export const GET_LOCALITY_FAILURE = "GET_LOCALITY_FAILURE";

export const UPLOAD_FILE_LOADING = "UPLOAD_FILE_LOADING";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";

export const POST_JOB_LOADING = "POST_JOB_LOADING";
export const POST_JOB_SUCCESS = "POST_JOB_SUCCESS";
export const POST_JOB_FAILURE = "POST_JOB_FAILURE";
export const CLEAR_POST_JOB = "CLEAR_POST_JOB";

export const POST_JOB_CLICKED = "POST_JOB_CLICKED";

export const EDIT_PROFILE_LOADING = "EDIT_PROFILE_LOADING";
export const EDIT_PROFILE_SUCCESS = "EDIT_PROFILE_SUCCESS";
export const EDIT_PROFILE_FAILURE = "EDIT_PROFILE_FAILURE";

export const CHANGE_PHONE_SEND_OTP_LOADING = "CHANGE_PHONE_SEND_OTP_LOADING";
export const CHANGE_PHONE_SEND_OTP_SUCCESS = "CHANGE_PHONE_SEND_OTP_SUCCESS";
export const CHANGE_PHONE_SEND_OTP_FAILURE = "CHANGE_PHONE_SEND_OTP_FAILURE";

export const CHANGE_PHONE_VERIFY_OTP_LOADING =
  "CHANGE_PHONE_VERIFY_OTP_LOADING";
export const CHANGE_PHONE_VERIFY_OTP_SUCCESS =
  "CHANGE_PHONE_VERIFY_OTP_SUCCESS";
export const CHANGE_PHONE_VERIFY_OTP_FAILURE =
  "CHANGE_PHONE_VERIFY_OTP_FAILURE";

export const SAVE_MANUALLY_CLICKED = "SAVE_MANUALLY_CLICKED";

export const GET_JOB_LOADING = "GET_JOB_LOADING";
export const GET_JOB_SUCCESS = "GET_JOB_SUCCESS";
export const GET_JOB_FAILURE = "GET_JOB_FAILURE";
export const CLEAR_JOB_DATA = "CLEAR_JOB_DATA";

export const GET_JOBS_HOME_LOADING = "GET_JOBS_HOME_LOADING";
export const GET_JOBS_HOME_SUCCESS = "GET_JOBS_HOME_SUCCESS";
export const GET_JOBS_HOME_FAILURE = "GET_JOBS_HOME_FAILURE";

export const GET_JOBTITLE_LOADING = "GET_JOBTITLE_LOADING";
export const GET_JOBTITLE_SUCCESS = "GET_JOBTITLE_SUCCESS";
export const GET_JOBTITLE_FAILURE = "GET_JOBTITLE_FAILURE";

export const GET_JD_LOADING = "GET_JD_LOADING";
export const GET_JD_SUCCESS = "GET_JD_SUCCESS";
export const GET_JD_FAILURE = "GET_JD_FAILURE";

export const GET_EDITED_JOB_FIELD_LOADING = "GET_EDITED_JOB_FIELD_LOADING";
export const GET_EDITED_JOB_FIELD_SUCCESS = "GET_EDITED_JOB_FIELD_SUCCESS";
export const GET_EDITED_JOB_FIELD_FAILURE = "GET_EDITED_JOB_FIELD_FAILURE";

export const SEND_VERIFICATION_EMAIL_LOADING =
  "SEND_VERIFICATION_EMAIL_LOADING";
export const SEND_VERIFICATION_EMAIL_SUCCESS =
  "SEND_VERIFICATION_EMAIL_SUCCESS";
export const SEND_VERIFICATION_EMAIL_FAILURE =
  "SEND_VERIFICATION_EMAIL_FAILURE";

export const IS_FIRST_JOB = "IS_FIRST_JOB";

export const GET_FORM_FIELDS_LOADING = "GET_FORM_FIELDS_LOADING";
export const GET_FORM_FIELDS_SUCCESS = "GET_FORM_FIELDS_SUCCESS";
export const GET_FORM_FIELDS_FAILURE = "GET_FORM_FIELDS_FAILURE";

export const ADD_CLIENT_LOADING = "ADD_CLIENT_LOADING";
export const ADD_CLIENT_SUCCESS = "ADD_CLIENT_SUCCESS";
export const ADD_CLIENT_FAILURE = "ADD_CLIENT_FAILURE";

export const UPDATE_CLIENT_LOADING = "UPDATE_CLIENT_LOADING";
export const UPDATE_CLIENT_SUCCESS = "UPDATE_CLIENT_SUCCESS";
export const UPDATE_CLIENT_FAILURE = "UPDATE_CLIENT_FAILURE";

export const GET_ORGANISATIONS_LOADING = "GET_ORGANISATIONS_LOADING";
export const GET_ORGANISATIONS_SUCCESS = "GET_ORGANISATIONS_SUCCESS";
export const GET_ORGANISATIONS_FAILURE = "GET_ORGANISATIONS_FAILURE";
export const GET_META_DATA_VER_SUCCESS = "GET_META_DATA_VER_SUCCESS";

export const GET_AVG_SALARY_LOADING = "GET_AVG_SALARY_LOADING";
export const GET_AVG_SALARY_SUCCESS = "GET_AVG_SALARY_SUCCESS";
export const GET_AVG_SALARY_FAILURE = "GET_AVG_SALARY_FAILURE";

export const SAVE_JOB_CLICKED = "SAVE_JOB_CLICKED";
export const FAMOUS_LOCATION_METADATA_LOADING =
  "FAMOUS_LOCATION_METADATA_LOADING";

export const FAMOUS_LOCATION_METADATA_FAILURE =
  "FAMOUS_LOCATION_METADATA_FAILURE";

export const FAMOUS_LOCATION_METADATA_SUCCESS =
  "FAMOUS_LOCATION_METADATA_SUCCESS";
